import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyNumbers]',
})
export class OnlyNumbersDirective {
  private regex: RegExp = new RegExp(/^[0-9]+$/);
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onkeydown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.trim();
    this.control.control.patchValue(input.value);
    if (!this.regex.test(input.value)) {
      input.value = input.value.replace(/[^0-9*]/g, '');
      this.control.control.patchValue(input.value);
    }
  }
}
